/// <amd-module name="Dashboards/WidgetHost/MessageComponents/ExtensionFailedMessage" />
import * as Resources from "Dashboards/WidgetHost/Resources";
import React = require("react");
import { localeFormat } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";

export interface ExtensionFailedMessageProps {
    extensionName: string;
    extensionUrl: string;
}

/** Detail View for Widgets which seem to be uninstalled or otherwise unavailable from EMS. */
export class ExtensionFailedMessage extends VssComponent<ExtensionFailedMessageProps> {
    public render(): JSX.Element {
        return (
            <div className={"extension-failed-dialog-content"}>
                <span className="flex-self-center">
                    <Link href={this.props.extensionUrl} target="_blank">
                        {localeFormat(Resources.ExtensionFailedWidget_DialogContentFormatText, this.props.extensionName)}
                    </Link>
                </span>
            </div>
        );
    }
}
